<template>

<div >     
         
      <v-container grid-list-md fluid fill-height >
        <v-layout        
          row wrap
        >
        <v-flex xs12 >
          <v-progress-linear color="carregando" v-show="loading" :indeterminate="true"></v-progress-linear>
        <v-card  v-show="mostraCartoes"  light class="Black--text" color="terciary">
        
              <v-card-title primary-title>
                <div class=" .pa-1 text-md-left headline">Cartões</div>
              </v-card-title>

              <v-list  three-line subheader="">
              
              <template v-for="(item, index) in cartoes">
                <v-subheader v-if="item.header" :key="item.header">Cartões</v-subheader>
                <v-divider :key="index"></v-divider>
                <v-list-tile  :key="item.num_cartao"  @click="verExtrato(item.num_cartao)">
                  <v-list-tile-action>
                    <v-icon color="primary" size="45">card_membership</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content >
                    <v-list-tile-title>Cartão: {{ item.num_cartao }}</v-list-tile-title>
                     <v-list-tile-sub-title>Saldo:  {{ formata_moeda(item.saldo) }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title>Validade: {{ item.validade }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>          
                        
              <v-spacer></v-spacer>
            
        
        </v-card>
        </v-flex>
        
          <!--<v-flex xs6>
            <v-card class="light-blue lighten-3"  color="primary">
             <v-icon x-large >insert_chart</v-icon> 
            <v-card-text class="px-0">EXTRATO</v-card-text>
            </v-card>
        </v-flex>

        <v-flex xs6>
            <v-card color="secondary">
              <v-icon x-large>map</v-icon>
            <v-card-text class="px-0"> 
              LOJAS</v-card-text>
            </v-card>
        </v-flex>-->
        </v-layout>
      </v-container>
      
 
</div>
    </template>

<script>
import { HTTP } from "../services/http.axios";
import { formata } from "../services/format";
export default {
  name: "Saldo",
  mixins: [formata],

  data: () => ({
    drawer: null,
    mostraCartoes: false,
    loading: false,
    valor: "",
    nome: "",
    cartoes: {
      num_cartao: "",
      validade: "",
      saldo: ""
    }
  }),
  computed: {
    getNome() {
      return window.sessionStorage.getItem("nome");
    }
  },
  methods: {
    verExtrato(cartao) {
      window.sessionStorage.setItem("cartao", cartao);
      this.$router.push({ name: "Extrato" });
    },

    formata_moeda(val) {
      let val1 = val / 100;
      let valor = this.formatar_moeda(val1);
      return valor;
    },
    buscaSaldoCartoes() {
      this.loading = true;
      HTTP.get(`cartao/lista/` + window.sessionStorage.getItem("cpf")).then(
        response => {
          if (response.data.error) {
            this.textSnack = response.data.error;
            this.snackbar = true;
          } else {
            this.cartoes = response.data;
            this.mostraCartoes = true;
          }
          this.loading = false;
        }
      );
    }
  },
  mounted() {
    this.buscaSaldoCartoes();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Saldo.vue